export function normalizePhone(phone:string) {
    return phone?.split(",")
        .map(p => p.replaceAll(/^[+]|[\s-]/g, ""))
}

export function containMyPhone(myPhone?:string, phone?:string) {
    if(!myPhone || !phone) {
        return false;
    }
    return normalizePhone(phone).indexOf(myPhone) > -1
}